import i18next from 'i18next';

const WEEKDAYS = () => [
  { id: '0', name: i18next.t('GENERAL.WEEKDAY_1_MONDAY') },
  { id: '1', name: i18next.t('GENERAL.WEEKDAY_2_TUESDAY') },
  { id: '2', name: i18next.t('GENERAL.WEEKDAY_3_WEDNESDAY') },
  { id: '3', name: i18next.t('GENERAL.WEEKDAY_4_THURSDAY') },
  { id: '4', name: i18next.t('GENERAL.WEEKDAY_5_FRIDAY') },
  { id: '5', name: i18next.t('GENERAL.WEEKDAY_6_SATURDAY') },
  { id: '6', name: i18next.t('GENERAL.WEEKDAY_7_SUNDAY') },
];

export const getLimitOrderDay = (deliveryDay, deliveryLeadTime) => {
  if (deliveryDay && deliveryLeadTime) {
    let nbWeek = 0;
    let limitOrderWeekDay = deliveryDay;
    let deliveryLeadTimeIdx = deliveryLeadTime;
    while (deliveryLeadTimeIdx > 0) {
      limitOrderWeekDay--;
      deliveryLeadTimeIdx--;
      if (limitOrderWeekDay < 0) {
        limitOrderWeekDay = 6;
        nbWeek++;
      }
    }
    return `${WEEKDAYS()[limitOrderWeekDay]['name']} ${nbWeek > 0 ? `(S-${nbWeek})` : ''}`;
  } else return '-';
};
